export const zhURL = {
  图文管理: '/admin/article',
  综合管理: '/admin/comprehensive',
  产品管理: '/admin/product',
  用户管理: '/admin/user'
}
export const enURL = {
  图文管理: '/admin/article',
  综合管理: '/admin/comprehensive',
  产品管理: '/admin/product',
  用户管理: '/admin/user'
}
export default {
  zhURL,
  enURL
};



// WEBPACK FOOTER //
// ./src/config/index.js